import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom"
import useFetchService from '../../hooks/use-fetch-service'

import { Row, Col, Card } from 'react-bootstrap'

import axios from 'axios'

import './style.css'

function ServiceCard() {
    const { data } = useFetchService();
    const [ media, setMedia ] = useState();

    let base64 = require("base-64");

    const username = `${process.env.REACT_APP_API_USERNAME_NEW_SITE}`;
    const password = `${process.env.REACT_APP_API_PASSWORD_NEW_SITE}`;
     
    const history = useNavigate();

    const handleclick = (event) => {
    const id = event.currentTarget.dataset.id;
      history(`/services/servicedetail/${id}`);
    }

    useEffect(() => {
      const fetchMedia = async () => {
        try {
          const { data: response } = await axios.get('https://vinod-soba.co.uk/wp-json/wp/v2/media?per_page=30', {
            headers: {
              Authorization: 'Basic ' +  base64.encode(username + ':' + password)
            }
          }
        
        );
          setMedia(response)
        } catch (error) {
         console.log("Media is not being passed",error);
        }   
      }
      fetchMedia();
    },[]);

console.log(media);

  return (
    <div className='py-4'>
        <h1 className='text-black'>Services</h1>
       <Row>
            {
            data.map(item  =>
            <Col md={6}>
                <Card style={{ width: '531.9px', height: '352.92', border: 'none', backgroundColor: '#DDE1D4'}} >
                  <Card.Header
                  style={{ border: 'none' }}
                  >
                    <div
                    data-id={item.id} 
                    onClick={handleclick} 
                    style={{ margin: '0 auto'}}
                    className="cta-primary-service" 
                    key={item.id} 
                    dangerouslySetInnerHTML={{__html: item.title.rendered}} />
                  </Card.Header>
                  <Card.Body>
                    <div dangerouslySetInnerHTML={{__html: item.content.rendered}} />
                  </Card.Body>
                </Card>
            </Col>
             )
            }
        </Row> 
    </div>
  )
}
export default ServiceCard